module.exports = __webpack_public_path__ + "img/logo.e509128c.jpg";